module.exports = __webpack_public_path__ + "img/vakifbank.976e94de.png";